var _defs, _ellipse, _path, _g, _path2, _line, _line2, _line3, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWavingHand(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#45413c;opacity:0.15;}.cls-2{fill:#ffcebf;}.cls-3{fill:#ffdcd1;}.cls-4{fill:none;stroke:#45413c;stroke-linecap:round;stroke-linejoin:round;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "384-waving-hand-2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "_Ellipse_",
    "data-name": "<Ellipse>",
    className: "cls-1",
    cx: 24,
    cy: 45.5,
    rx: 12.5,
    ry: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_Path_",
    "data-name": "<Path>",
    className: "cls-2",
    d: "M33.46,19.26l-.13,3.26L22.11,11.29A2.59,2.59,0,0,0,18.67,11a2.49,2.49,0,0,0-.19,3.7l-1.59-1.59a2.77,2.77,0,0,0-3.77-.21,2.67,2.67,0,0,0-.1,3.87L13,16.72a2.53,2.53,0,0,0-3-.46,2.5,2.5,0,0,0-.53,3.94l3,3a2.19,2.19,0,0,0-3.24.16,2.28,2.28,0,0,0,.24,3L22,39a9.39,9.39,0,0,0,13.37-.06,14.47,14.47,0,0,0,4-10.81L39,16a1.08,1.08,0,0,0-1.08-1h0A4.45,4.45,0,0,0,33.46,19.26Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_Group_",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_2",
    "data-name": "<Path>",
    className: "cls-3",
    d: "M33.33,22.52,22.11,11.29A2.59,2.59,0,0,0,18.67,11a2.48,2.48,0,0,0-.36,3.49,1.8,1.8,0,0,1,.36-.37,2.59,2.59,0,0,1,3.44.27l9.66,9.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_3",
    "data-name": "<Path>",
    className: "cls-3",
    d: "M39.09,19.12,39,16a1.08,1.08,0,0,0-1.08-1,4.45,4.45,0,0,0-4.45,4.29l-.13,3.26.13-.14a4.46,4.46,0,0,1,4.45-4.29A1.17,1.17,0,0,1,39.09,19.12Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "_Path_4",
    "data-name": "<Path>",
    className: "cls-4",
    d: "M33.46,19.26l-.13,3.26L22.11,11.29A2.59,2.59,0,0,0,18.67,11a2.49,2.49,0,0,0-.19,3.7l-1.59-1.59a2.77,2.77,0,0,0-3.77-.21,2.67,2.67,0,0,0-.1,3.87L13,16.72a2.53,2.53,0,0,0-3-.46,2.5,2.5,0,0,0-.53,3.94l3,3a2.19,2.19,0,0,0-3.24.16,2.28,2.28,0,0,0,.24,3L22,39a9.39,9.39,0,0,0,13.37-.06,14.47,14.47,0,0,0,4-10.81L39,16a1.08,1.08,0,0,0-1.08-1h0A4.45,4.45,0,0,0,33.46,19.26Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "_Path_5",
    "data-name": "<Path>",
    className: "cls-4",
    x1: 12.34,
    y1: 23.18,
    x2: 18.4,
    y2: 29.23
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "_Path_6",
    "data-name": "<Path>",
    className: "cls-4",
    x1: 13.02,
    y1: 16.78,
    x2: 21.93,
    y2: 25.69
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    id: "_Path_7",
    "data-name": "<Path>",
    className: "cls-4",
    x1: 18.48,
    y1: 14.72,
    x2: 25.69,
    y2: 21.94
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "_Path_8",
    "data-name": "<Path>",
    className: "cls-4",
    d: "M33.33,22.52l-3.57,3.57a6,6,0,0,0,0,8.49h0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "_Path_9",
    "data-name": "<Path>",
    className: "cls-4",
    d: "M24.11,8.76a9.06,9.06,0,0,1,4.31,2,9.72,9.72,0,0,1,2.7,4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "_Path_10",
    "data-name": "<Path>",
    className: "cls-4",
    d: "M24.68,6.09A11.06,11.06,0,0,1,30,8.51a11.84,11.84,0,0,1,3.33,4.93"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "_Path_11",
    "data-name": "<Path>",
    className: "cls-4",
    d: "M4.65,24.24a9,9,0,0,0,.79,4.67,9.65,9.65,0,0,0,3.17,3.63"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "_Path_12",
    "data-name": "<Path>",
    className: "cls-4",
    d: "M1.92,24.1a11.07,11.07,0,0,0,1,5.77,12,12,0,0,0,3.91,4.49"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWavingHand);
export default __webpack_public_path__ + "static/media/wavingHand.68a92d44d0f7b4e916e9cb535f33f1ab.svg";
export { ForwardRef as ReactComponent };